import React, { useState, useEffect } from 'react';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import FormHelperText from '@mui/material/FormHelperText';
import FormControl from '@mui/material/FormControl';
import ButtonGroup from '@mui/material/ButtonGroup';
import Button from '@mui/material/Button';
import { FixedSizeList as List } from 'react-window';
import { uniqBy } from '../../../utils/collections';
import { StrikeThroughHeader } from 'components/Headers/strikethrough-header/strikethrough-header';
import SharepointLink from 'components/Global/SharepointLink/SharepointLink';
import { GetNewsList } from '../../../api/news';
import { useUser } from 'context/UserContext';
import LoadingIndicator from 'components/Global/loading-indicator/loading-indicator';
import './Index.scss';
import { useQuery } from '@tanstack/react-query';

function Index() {
  const [filteredData, setFilteredData] = useState();
  const query = useQuery({
    queryKey: ['getNewsList', '0'],
    queryFn: () => GetNewsList()(),
  });
  const user = useUser();

  const elements = [];

  if (query.isPending) {
    elements.push(<LoadingIndicator key="loading" />);
  }
  if (query.isSuccess && query.data) {
    elements.push(<NewsList key="newsList" data={filteredData ? filteredData : query.data} />);
  }

  return (
    <div id="news-root">
      <StrikeThroughHeader>News Archive</StrikeThroughHeader>
      <Filters
        data={query.data ? query.data : undefined}
        callback={setFilteredData}
        isHO={user.isHO}
        division={user.division}
      />
      <div id="page-content">{elements}</div>
    </div>
  );
}

function Filters({ data, callback, isHO, division }) {
  const [searchText, setSearchText] = useState();
  const [categoryFilter, setCategoryFilter] = useState();
  const [divisionFilter, setDivisionFilter] = useState();
  const [categories, setCategories] = useState();

  useEffect(() => {
    if (data) {
      getCategories();
    }
  }, [data]);

  useEffect(() => {
    if (data) {
      filterData();
    }
  }, [searchText, categoryFilter, divisionFilter]);

  useEffect(() => {
    if (isHO) {
      setDivisionFilter(division);
    }
  }, [isHO, division]);

  const getVariant = (buttonStr) => {
    if (divisionFilter == buttonStr) {
      return 'contained';
    }
    return 'outlined';
  };

  const getCategories = () => {
    let temp = data.filter((newsItem) => {
      if (
        newsItem.category != null &&
        newsItem.category != 'null' &&
        newsItem.category != undefined &&
        newsItem.category.trim() != ''
      ) {
        return newsItem;
      }
    });
    temp = uniqBy(temp, 'Category');
    setCategories(temp.map((newsItem) => ({ value: newsItem.category, label: newsItem.category })));
  };
  const filterData = () => {
    let temp = data;
    if (searchText != '' && searchText != null) {
      temp = temp.filter(
        (element) => element.title && element.title.toLowerCase().includes(searchText.toLowerCase())
      );
    }
    if (categoryFilter != '' && categoryFilter != null) {
      temp = temp.filter(
        (element) => element.category && element.category.includes(categoryFilter)
      );
    }
    if (divisionFilter != null) {
      temp = temp.filter(
        (element) =>
          element.division &&
          (element.division == divisionFilter || element.division == 'All Sales')
      );
    }
    callback(temp);
  };

  return (
    <div className="filters">
      <div className="filter">
        <TextField
          key="override"
          onChange={(e) => setSearchText(e.target.value)}
          variant="outlined"
          margin="dense"
          id="search-text"
          placeholder="Search..."
        />
      </div>
      <div className="filter">
        <FormControl id="producer-alt-select" className="exit-swipe-left" key="alternate">
          <Autocomplete
            options={categories ?? []}
            getOptionLabel={(option) => option.label}
            onChange={(_, val) => {
              setCategoryFilter(val ? val.value : '');
            }}
            renderInput={(params) => <TextField {...params} placeholder="Category" />}
          />
          <FormHelperText>Select a news category</FormHelperText>
        </FormControl>
      </div>
      {isHO && (
        <div className="filter">
          <ButtonGroup color="primary">
            <Button
              onClick={() => {
                setDivisionFilter('CASG');
              }}
              variant={getVariant('CASG')}
            >
              CASG
            </Button>
            <Button
              onClick={() => {
                setDivisionFilter('ISD');
              }}
              variant={getVariant('ISD')}
            >
              ISD
            </Button>
          </ButtonGroup>
        </div>
      )}
    </div>
  );
}

function NewsList({ data }) {
  function renderRow({ index, style }) {
    return (
      <li key={index}>
        <SharepointLink
          style={style}
          linkType={data[index].linkTypeID}
          link={data[index].documentLink}
          baseUrl={`${process.env.REACT_APP_AGENTPORTAL_PREFIX}/News`}
        >
          {data[index].title}
        </SharepointLink>
      </li>
    );
  }

  return (
    <div>
      {data.length > 0 ? (
        <List
          height={35 * 23}
          itemCount={data.length}
          itemSize={35}
          width="100%"
          outerElementType="ul"
        >
          {renderRow}
        </List>
      ) : (
        <>No Results Returned.</>
      )}
    </div>
  );
}

export { Index };
